<template>
    <div
        class="form-group"
        :class="[
            {
                'form-row': horizontal,
            },
        ]"
    >
        <label
            :class="[
                { 'col-form-label': horizontal },
                horizontal ? class_label : '',
                size == 'sm' ? 'col-form-label-sm' : '',
            ]"
            v-if="label != ''"
        >
            {{ label }}
        </label>
        <div
            :class="[
                horizontal ? class_input : '',
                size == 'sm' ? 'input-group-sm' : '',
            ]"
        >
            <model-select
                :options="options"
                v-model="item_select"
                :name="name"
                :placeholder="placeholder"
                class="form-control"
                :class="{
                    'is-valid': isValid == true,
                    'is-invalid': isValid == false,
                }"
                @change="onChange($event)"
            >
            </model-select>
            <div v-if="isValid == false" class="invalid-feedback">
                {{ invalidFeedback }}
            </div>
        </div>
    </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import axios from "axios";
export default {
    name: "SelectAsync",
    components: {
        ModelSelect,
    },
    data() {
        return {
            options: [],
            item_select: this.value,
            class_label: "col-sm-3",
            class_input: "col-sm-9",
        };
    },
    props: {
        label: {
            type: String,
            default: "",
        },
        name: {
            type: String,
            default: "",
        },
        className: {
            type: String,
            default: "",
        },
        placeholder: {
            type: String,
            default: "Select item",
        },
        isValid: {
            type: Boolean,
            default: null,
        },
        value: {
            default: null,
        },
        horizontal: {
            default: false,
        },
        size: {
            default: undefined,
        },
        invalidFeedback: {
            default: undefined,
        },

        /* Custom props */
        endpoint: {
            type: String,
        } /* modelName */,
        optionsValue: {
            type: String,
        } /* valueAttribute */,
        optionsLabel: {
            type: String,
        } /* valueName */,
    },
    watch: {
        item_select(newValue) {
            console.log(newValue);
            this.$emit("update:value", newValue);
            this.$emit("change", newValue);
        },
        value(newValue) {
            this.item_select = newValue;
        },
    },
    methods: {
        getProviderGroup: async function () {
            try {
                const { data } = await axios.get(this.endpoint);
                this.options = data.items.map((item) => {
                    return {
                        value: item[this.optionsValue],
                        text: item[this.optionsLabel],
                    };
                });
            } catch (error) {
                console.log(error);
            }
        },
        setHorizontalClass: function () {
            if (this.horizontal.label) {
                this.class_label = this.horizontal.label;
            }
            if (this.horizontal.input) {
                this.class_input = this.horizontal.input;
            }
        },
        onChange(event) {},

        setComponentValue(value) {
            this.$set(this, 'item_select', value);
        },
        getComponentValue() {
            return this.item_select;
        },
    },
    mounted() {
        this.getProviderGroup();
        this.setHorizontalClass();
    },
};
</script>

<style lang="scss">
@import "node_modules/bootstrap/scss/bootstrap.scss";
.ui.dropdown {
    & .icon {
        background: transparent !important;
    }
}
.ui.selection.dropdown {
    & .text.default {
        color: #6c757d;
    }
}
.ui.selection.dropdown.is-invalid {
    @extend .is-invalid;
    & .icon {
        opacity: 0;
    }
}
.ui.selection.dropdown.is-valid {
    @extend .is-valid;
    & .icon {
        opacity: 0;
    }
}

.input-group-sm {
    & .ui.search.dropdown {
        & .text {
            top: -0.2em;
        }
    }
}
</style>
